import { render, staticRenderFns } from "./NewSubjectAreaModal.vue?vue&type=template&id=42477aef&lang=pug&"
import script from "./NewSubjectAreaModal.vue?vue&type=script&lang=js&"
export * from "./NewSubjectAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports